import DressageLine from "./DressageLine";

export default class DressageLines {
  private data: DressageLine[] = [];

  constructor(items?: DressageLine[] | undefined) {
    if (items) {
      items.forEach(i => this.data.push(i));
    }
  }

  add(item: DressageLine) {
    this.data.push(item);
  }

  map<T>(mapFunction: (arg: DressageLine) => T): T[] {
    return Array.from(this.data.values()).map(mapFunction);
  }

  sort(sortFunction: (arg1: DressageLine, arg2: DressageLine) => number): DressageLine[] {
    return Array.from(this.data.values()).sort(sortFunction);
  }

  filter<T>(filterFunction: (arg: DressageLine) => boolean): DressageLines {
    return new DressageLines(Array.from(this.data.values()).filter(filterFunction));
  }

  forEach(forEachFunction: (arg: DressageLine, index: number) => void): void {
    return Array.from(this.data.values()).forEach(forEachFunction);
  }
}
